import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=d6b39486&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerModal.vue?vue&type=style&index=0&id=d6b39486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b39486",
  null
  
)

export default component.exports